import React from 'react';
import { Card, Row, Col } from 'antd';
import { useNavigate } from 'react-router-dom';
import workspace from '../../Services/AppData/AppData.json';
import {
  FileTextOutlined,
  FileDoneOutlined,
  DollarOutlined,
  FundOutlined,
  ProjectOutlined
} from '@ant-design/icons';

const iconMap = {
  FileTextOutlined,
  FileDoneOutlined,
  DollarOutlined,
  FundOutlined,
  ProjectOutlined
};

const WorkspacePage = ({ handleClose, singleColumn = false }) => {
  const navigate = useNavigate();

  const handleClikc = async (to) => {
    await navigate(to);
    if (typeof handleClose === 'function') {
      handleClose();
    }
  };

  return (
    <div style={{ padding: 24 }}>
      <Row gutter={[16, 16]}>
        {workspace.workspaceData.map((item, index) => {
          const IconComponent = iconMap[item.icon];
          return (
            <Col
              key={index}
              xs={24}
               sm={singleColumn ? 24 : 12}
              md={singleColumn ? 24 : 8}
              lg={singleColumn ? 24 : 6}
              xl={singleColumn ? 24 : 6}
            >
              <Card
                hoverable
                style={{
                  textAlign: 'center',
                  borderRadius: 12,
                  boxShadow: '0 2px 8px rgba(0,0,0,0.05)',
                  height: '100%'
                }}
                onClick={() => handleClikc(item.to)}
              >
                <div style={{ marginBottom: 12 }}>
                  <IconComponent
                    style={{
                      fontSize: item.fontSize || 40,
                      color: item.color
                    }}
                  />
                </div>
                <h3 style={{ margin: 0 }}>{item.title}</h3>
              </Card>
            </Col>
          );
        })}
      </Row>
    </div>
  );
};

export default WorkspacePage;
